import { AUTH_TYPES, TEMPLATE_CATEGORIES } from './constants.js'

export const activecampaignTemplate = {
	id: 'activecampaign',
	guid: '8dcdd1b2-5f4a-4b2e-9c13-7a1d2f3b4c5d',
	name: 'ActiveCampaign',
	category: TEMPLATE_CATEGORIES.MARKETING,
	popularity: 'Popular',
	color: '#356ae6',
	icon: 'mdi-email-sync',
	description: 'Connect to ActiveCampaign for customer experience automation.',
	features: ['API Key Auth', 'Email Marketing', 'Marketing Automation', 'CRM'],
	configFields: [
		{ name: 'apiKey', label: 'API Key', type: 'password', required: true, placeholder: 'Enter your ActiveCampaign API key' },
		{ name: 'accountUrl', label: 'Account URL', type: 'text', required: true, placeholder: 'https://youraccountname.api-us1.com' }
	],
	endpoints: [
		{
			name: 'Create/Update Contact',
			url: '{account_url}/api/3/contacts/sync',
			method: 'POST',
			description: 'Create or update a contact in ActiveCampaign',
			cassieObjectID: -3,
			incrementField: 'SyrenisID',
			resetIncrementValue: false,
			fields: [
				{ name: 'Email1', filter: '' },
				{ name: 'Forename', filter: '' },
				{ name: 'Surname', filter: '' }
			],
			requestBody: '{ "contact": { "email": "[PLACEHOLDER_EMAIL1]", "firstName": "[PLACEHOLDER_FORENAME]", "lastName": "[PLACEHOLDER_SURNAME]" }}',
			headers: [
				{ Name: 'Api-Token', value: '[API_KEY]' },
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [{ code: 201, message: '' }]
		},
		{
			name: 'Set Contact Opt-In',
			url: '{account_url}/api/3/contact/sync',
			method: 'POST',
			description: 'Mark contact option',
			cassieObjectID: -5,
			incrementField: 'PreferenceID',
			resetincrementValue: false,
			fields: [
				{ name: 'Email1', filter: '' },
				{ name: 'ConsentValue', filter: '' }
			],
			requestBody: '{ "contact": { "email": "[PLACEHOLDER_EMAIL1]", "status": "[PLACEHOLDER_CONSENTVALUE]" }}',
			headers: [
				{ Name: 'Api-Token', value: '[API_KEY]' },
				{ Name: 'Content-Type', value: 'application/json' }
			],
			successResponses: [{ code: 200, message: '' }]
		}

	],
	defaults: {
		endpointAddress: 'https://[account].api-us1.com',
		authenticationTypeId: AUTH_TYPES.API_KEY,
		frequencyInSeconds: 0,
		notes: 'ActiveCampaign customer experience automation platform integration.'
	}
}
